import React, { useEffect, useState } from "react";

// Section A: public. Sticky "back to top" button pinned to the
// bottom-right corner of the viewport on content pages (see
// ArticleDetailPage.js, TopicDetailPage.js, IssueTopicDetailPage.js) —
// mirrors Footnotes.js's bottom-left button. Stays hidden until
// .site-header has fully scrolled out of view, then scrolls smoothly
// back up to it on click.
function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const header = document.querySelector(".site-header");
    if (!header) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(header);
    return () => observer.disconnect();
  }, []);

  function handleClick() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <button
      type="button"
      className={`scroll-top-fab${visible ? " scroll-top-fab--visible" : ""}`}
      onClick={handleClick}
      aria-label="بازگشت به بالای صفحه"
      tabIndex={visible ? 0 : -1}
    >
      <span className="scroll-top-fab-arrow" aria-hidden="true">
        ↑
      </span>
    </button>
  );
}

export default ScrollToTopButton;
